<template>
    <div id="admin" class="admin">
        <router-view></router-view>
    </div>
</template>

<script>
    const log = new Log("Page/admin");
    export default {
        name: "admin"
    }
</script>

<style lang="less">
    #admin {
        position: relative;
        overflow: hidden;
        width: 100%;
        padding: 10px 0;
        border-radius: 5px;
        background-color: #ffffff
    }
</style>